module.exports = __webpack_public_path__ + "static/img/life-proposal7.629d9106.png";